import {useCopyFeedback, type CopyControl} from "home/components/shareLink";
import {offerEvents} from "upsell/offerEvents";
import {inviteSentByCopy} from "./inviteFunnel";

/**
 * A referrer's share control: it copies their invite link and reports the hand-out
 * (kitecorp/transferify-api-service#1582).
 *
 * A thin adapter and nothing else. `./inviteFunnel` owns the one rule — a copy that failed handed
 * nobody anything — and `upsell/offerEvents` is the seam this names; nothing here knows a beacon
 * exists, which is the owner's 2026-08-27 separation swept by
 * `scripts/offer-telemetry-separation-sweep.mjs`.
 *
 * <b>ONE adapter for both of the referrer's share controls</b> — the account card's code tag and the
 * transfer-success card's invite tag — so the funnel cannot end up counting one of them and not the
 * other, which is the failure `invite_sent` exists to remove rather than repeat.
 *
 * <b>The report can never cost the reader their copy.</b> The emitter isolates each listener's throw
 * and the transports underneath it are fire-and-forget, so a blocked or failed beacon leaves the link
 * on the clipboard and the button in its "Copied" state exactly as it was. The copy is also awaited
 * BEFORE anything is reported, which is what makes a refused clipboard permission count as no invite
 * instead of a silent one.
 */
export function useInviteShare(url: string): CopyControl {
	const {copied, copy} = useCopyFeedback(url);
	return {
		copied,
		copy: async () => {
			const handedOut = await copy();
			if (inviteSentByCopy(handedOut)) {
				offerEvents.inviteSent();
			}
			return handedOut;
		},
	};
}
